import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import HelpButton from 'help/HelpButton';
import {RelevantTemplatesTableQuery} from 'schemas/relevant-templates/__generated/RelevantTemplatesTableQuery';
import {RELEVANT_TEMPLATES_DESCRIPTION_STRING} from 'schemas/relevant-templates/RelevantTemplatesConstants';
import RelevantTemplatesCriteriaForm from 'schemas/relevant-templates/RelevantTemplatesCriteriaForm';
import {RelevantTemplatesListingCriteria} from 'schemas/relevant-templates/useRelevantTemplatesListing';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import {HookSetState} from 'util/Types';

type SubtemplateNodeTemplateCollection = ExtractByTypename<
  RelevantTemplatesTableQuery['relevantTemplatesListing']['relevantTemplates'][number]['template'],
  'SubtemplateNode'
>['templateCollection'];

type TemplateNodeTemplateCollection = ExtractByTypename<
  RelevantTemplatesTableQuery['relevantTemplatesListing']['relevantTemplates'][number]['template'],
  'TemplateNode'
>['templateCollection'];

interface RelevantTemplatesHelpContentProps {
  schemaType: string;
}

export function RelevantTemplatesHelpContent({schemaType}: RelevantTemplatesHelpContentProps): JSX.Element {
  const schemaTypeName = schemaType === ModelTypeConstants.TAG_SCHEMA ? 'Registration' : 'Result';
  return (
    <div>
      A relevant template uses a schema as a {schemaTypeName} table or references a schema field within a
      lookup column. See{' '}
      <a
        href="https://help.benchling.com/hc/articles/9684224961805"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>{' '}
      for details.
    </div>
  );
}

interface RelevantTemplatesHeaderProps {
  selectedArchivePurposeFilters: Array<string>;
  templateCollections: Array<TemplateNodeTemplateCollection | SubtemplateNodeTemplateCollection>;
  listingCriteria: RelevantTemplatesListingCriteria;
  onChange: HookSetState<RelevantTemplatesListingCriteria>;
  onChangeSelectedArchivePurposeFilters: HookSetState<Array<string>>;
  schemaType: string;
}

/**
 * Displays the tab description, search bar, and collection filter dropdown.
 * @package
 */
export function RelevantTemplatesHeader(props: RelevantTemplatesHeaderProps): JSX.Element {
  return (
    <>
      <div className="u-small-spacing-bottom">
        {RELEVANT_TEMPLATES_DESCRIPTION_STRING}
        <HelpButton
          iconClassName={css(styles.helpButton)}
          renderContent={() => <RelevantTemplatesHelpContent schemaType={props.schemaType} />}
          placement={FloatingPlacement.RIGHT}
        />
      </div>
      <RelevantTemplatesCriteriaForm {...props} />
    </>
  );
}

const styles = StyleSheet.create({
  helpButton: {
    marginLeft: 6,
  },
});
